import type { ComponentProps } from "react";

import {
  sendMessageToReactNativeWebView,
  WEB_VIEW_ACTIONS,
} from "@/shared/lib";
import { useSettingsStore } from "@/shared/stores";
import { Switch } from "@/shared/ui";

type BiometricSwitchProps = Omit<ComponentProps<typeof Switch>, "checked">;

export const BiometricSwitch = ({ ...props }: BiometricSwitchProps) => {
  const isBiometricEnabled = useSettingsStore(
    (state) => state.isBiometricEnabled,
  );

  const handleOnCheckedChange = (checked: boolean) => {
    sendMessageToReactNativeWebView({
      type: WEB_VIEW_ACTIONS.ON_CHANGE_BIOMETRIC,
      payload: { checked },
    });
  };

  return (
    <Switch
      {...props}
      checked={isBiometricEnabled}
      onCheckedChange={handleOnCheckedChange}
      variant="simple"
    />
  );
};
